const notifications = {
    addToDesktop: {
        description: 'Add our icon to your desktop: click «Share» and select «Add to Home Screen»',
        button: 'OK',
    },
};

export default notifications;
